<style lang="scss">
  @import "@/assets/scss/vuexy/pages/List.scss";
</style>

<template>
  <div id="data-list-list-view" class="data-list-container mt-2 px-">
    <vx-card class="grid-view-item mb-base overflow-hidden">
      <h4>{{$t('Labels.Detail')}}</h4>
      <table cellspancing="5" class="border-separate mt-5">
        <tbody>
          <tr>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Client')}}</td>
            <td class=" px-2 py-1">{{license.company.name}}</td>
          </tr>
          <tr>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Start')}}</td>
            <td class=" px-2 py-1">{{license.begin_at}}</td>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Expire')}}</td>
            <td class=" px-2 py-1">{{license.expire_at}}</td>
          </tr>
          <tr>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Status')}}</td>
            <td class=" px-2 py-1">
              <span v-if="license.status == 'A'" class="p-2 rounded bg-success text-white">{{$t('Labels.Active')}}</span>
              <span v-if="license.status == 'I'" class="p-2 rounded bg-grey text-white">{{$t('Labels.Inactive')}}</span>
              <span v-if="license.status == 'E'" class="p-2 rounded bg-red text-white">{{$t('Labels.Expired')}}</span>
            </td>
          </tr>
          <tr>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.CreatedAt')}}</td>
            <td class=" px-2 py-1">{{license.created_at}}</td>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Creator')}}</td>
            <td class=" px-2 py-1">{{license.user!= null ?license.user.first_name + ' ' + license.user.last_name:''}}</td>
          </tr>
        </tbody>
      </table>
    </vx-card>
    <vx-card class="grid-view-item mb-base overflow-hidden">
      <h4>{{$tc('Labels.Device',2)}}</h4>
      <div class="vx-row mb-5 mt-5">
        <div class="vx-col md:w-1/3 w-full">
            <label>{{$t('Labels.Type')}}</label>
            <v-select :options="types" v-model="filter.device_type_uuid" :reduce="org => org.uuid" label="name"/>
        </div>
        <div class="vx-col md:w-1/3 w-full">
          <vs-input class="inline-block" :label="$t('Labels.Serie')" :placeholder="$t('Labels.Serie')" v-model="filter.serie" />
        </div>
        <div class="vx-col md:w-1/6 w-full">
          <vs-button class="mt-5" @click="getResponse()" radius color="primary" type="filled" icon="search"></vs-button>         
        </div>
        <!--<div class="vx-col md:w-1/3 w-full">
          <vs-input class="inline-block" :label="$t('Labels.PublicKey')" :placeholder="$t('Labels.PublicKey')" v-model="file.name" readonly />
          <input type="file" id="file" ref="file" @change="handleFileUpload()" class="hidden"/>
          <vs-button class="inline-block ml-2" color="primary" type="filled" @click="$refs.file.click()" icon="backup"></vs-button>
        </div>-->
        <div class="vx-col md:w-1/6 w-full pt-4">
          <vs-button @click="requestPassword()" class="bg-primary float-right ml-4" type="filled">{{$t("Labels.Assign")}}</vs-button>
        </div>
      </div>
      <vs-table v-if="response" :data="response" multiple  v-model="selected">
        <template slot="thead">
          <vs-th sort-key="serie">
            {{$t('Labels.Serie')}}
          </vs-th>
          <vs-th sort-key="device_type.name">
            {{$t('Labels.DeviceType')}}
          </vs-th>
        </template>

        <template  slot-scope="{data}">
          <vs-tr :data="item" :key="index" v-for="(item, index) in data" >
            <vs-td :data="item.serie">
              {{item.serie}}
            </vs-td>
            <vs-td :data="item.device_type != null ?item.device_type.name: ''">
              {{item.device_type != null ?item.device_type.name: ''}}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-pagination v-if="response" :max="25" :total="totalPages" v-model="currentx"></vs-pagination>
    </vx-card>
    </div>
    
</template>

<script>
import vSelect from 'vue-select'
import {request} from '@/request.js'
import listItem from '@/components/listItem/listItem.vue'
import listAlertItem from '@/components/listAlertItem/listAlertItem.vue'
import {empty} from '@/helpers.js'
import {globalPass, globalPassActions} from '@/globalPass'

export default {
  components: {
    'v-select': vSelect,
    listItem,
    listAlertItem
  },
  data () {
    return {
      isMounted: false,
      response: [],
      currentx: 1,
      active:false,
      totalPages: 0,
      countRows: 0,
      oldCurrentPage: 1,
      filter:{
        devEui:'',
        serie:'',
        dev_address: '',
        status:'',
        limit:100000,
        offset: 0,
        byColumn: 'uuid',
        byOrder: 'ASC',
        app_id: '',
        device_type_uuid:'',
        license_uuid: this.$route.params.uuid,
        unassign: true
      },
      statusOptions: [
        {label: 'Almacén', value: 'A'},
        {label: 'Cliente Activo', value: 'CA'},
        {label: 'Cliente Inactivo', value: 'CI'},
        {label: 'Soporte', value: 'S'},
        {label: 'Baja', value: 'D'}
      ],
      apps:[],
      types:[],
      selected: [],
      license:{},
      uuid: this.$route.params.uuid,
      file:'',
      selectedUuids:''
    }
  },

  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    }
  },


  methods: {
    async getLicense () {
      console.log(this.uuid)
      const params = {
        url: `licenses/${this.uuid}`,
        method: 'GET',
        params: {}
      }
      await request(params).then(response => {
        this.license = response.data.data
      })
    },
    async getApps () {
      this.$vs.loading()
      const params = {
        url: 'applications',
        method: 'GET',
        params:{
          limit:10000,
          offset:0,
          byColumn:'name',
          byOrder:'asc'
        }
      }
      await request(params).then(response => {
        this.apps = response.data.data.rows
      }).finally(() => {
        this.$vs.loading.close()
      })                        
    },
    async getTypes () {
      this.$vs.loading()
      const params = {
        url: 'device_types',
        method: 'GET',
        params:{}
      }
      await request(params).then(response => {
        this.types = response.data.data
        this.types.unshift({
          uuid:'',
          name: this.$t('Labels.All')
        })
        this.filter.device_type_uuid = ''
      }).finally(() => {
        this.$vs.loading.close()
      })                        
    },
    async getResponse () {
      const params = {
        url: 'devices',
        method: 'GET',
        params: this.filter
      }
      await request(params).then(response => {
        this.response = response.data.data.rows
        this.countRows = response.data.data.count
      }).catch(() => {
        this.response = []
        this.totalPages = 0
        this.countRows = 0
      }).finally(() => {
        this.$vs.loading.close()
      })
    },
    handleFileUpload () {
      this.file = this.$refs.file.files[0]
      const reader = new FileReader()
      console.log(this.file)

      // Leemos el archivo subido y se lo pasamos a nuestro fileReader
      reader.readAsDataURL(this.$refs.file.files[0])
    },
    requestPassword () {
      globalPassActions.show()
    },
    async assign () {
      //const form = new FormData();
      //form.append('file', this.file)
      //form.append('uuids', this.selectedUuids)
      const params = {
        url: 'licenses/assign_license',
        method: 'PUT',
        params: {
          uuids: this.selectedUuids
        }
      }
      await request(params).then(response => {
        this.data = response.data.data
      })
    }
  },

  created () {
    this.$route.meta.breadcrumb[1].title = this.$t('Path.Licenses')
    this.$route.meta.breadcrumb[2].title = this.$t('Path.Assign')
    this.$route.meta.pageTitle = this.$t('Path.Assign')
    this.$router.replace({query: {temp: Date.now()}})
    this.$router.replace({query: {temp: undefined}})
    this.getLicense()
    this.getApps()
    this.getTypes()
    this.getResponse()
  },

  mounted () {
    this.isMounted = true
  },

  updated () {
    if (this.oldCurrentPage != this.currentx) {
      this.oldCurrentPage = this.currentx
      this.getResponse()
    }
  },
  computed: {
    isVisiblePassword () {
      return globalPass.active
    }
  },
  watch:{
    countRows (val) {
      let limit = this.filter.limit
      if (limit > val) limit = val
      let pages = val / limit
      if (val % limit > 0) pages++
      this.totalPages = pages
    },
    selected (val) {
      this.selectedUuids = ''
      val.forEach((item) => {
        this.selectedUuids += `${item.uuid },`
      })
      this.selectedUuids = this.selectedUuids.slice(0, -1)
    },
    isVisiblePassword (visible) {
      if (!empty(globalPassActions.get()) && visible == false) this.assign()
    }
  }
}
</script>
